import updateUserPreference from './update-user-preference';
import constants from './constants';

export default {
  constants,
  updateUserPreference,
};
